export default __webpack_public_path__ + "static/media/CBS_news_splash_logo.fed5a8cf.svg";